import React, { useEffect, useMemo, useRef, useState } from "react";
import "./OrdersListModal.css";

export default function OrdersListModal({
  title,
  variant = "default",        // "close" | "invoice" | "default"
  orders = [],
  onClose,
  onCloseOrder,               // (orderId) => void
  onViewOrder,                // (orderId) => void
  primaryLabel = "Zamknij",   // tekst przycisku akcji
  emptyText = "Brak zleceń do wyświetlenia.",
}) {
  const [query, setQuery] = useState("");
  const searchRef = useRef(null);

  useEffect(() => {
    // focus w pole szukania po otwarciu
    if (searchRef.current) searchRef.current.focus();

    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return orders;
    return orders.filter((o) => {
      const exec = `${o.executor_first_name || ""} ${o.executor_last_name || ""}`.toLowerCase();
      return (
        (o.nr_ref || "").toLowerCase().includes(q) ||
        (o.tytul  || "").toLowerCase().includes(q) ||
        exec.includes(q)
      );
    });
  }, [orders, query]);

  const handlePrimary = (order) => {
    const label = `${order.nr_ref} ${order.tytul}`.trim();
    if (window.confirm(`Na pewno ${primaryLabel.toLowerCase()} zlecenie:\n${label}?`)) {
      onCloseOrder?.(order.id);
    }
  };

  const closeOnOverlay = (e) => {
    // zamknij, gdy klik na tło
    if (e.target.classList.contains("orders-modal__overlay")) onClose();
  };

  return (
    <div className="orders-modal__overlay" onMouseDown={closeOnOverlay} role="dialog" aria-modal="true">
      <div className={`orders-modal ${variant}`}>
        {/* HEAD */}
        <header className="orders-modal__header">
          <h3 className="orders-modal__title">
            {title}
            <span className="orders-modal__badge">{orders.length}</span>
          </h3>
          <button className="orders-modal__close-x" onClick={onClose} aria-label="Zamknij">×</button>
        </header>

        {/* TOOLS */}
        <div className="orders-modal__tools">
          <input
            ref={searchRef}
            type="text"
            className="orders-modal__search"
            placeholder="Szukaj po nr, tytule lub wykonawcy…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        {/* LISTA */}
        <div className="orders-modal__list">
          {filtered.length === 0 ? (
            <div className="orders-modal__empty">{emptyText}</div>
          ) : (
            filtered.map((o) => (
              <div key={o.id} className="orders-row">
                <div className="orders-row__main">
                  <div className="orders-row__top">
                    <span className="orders-row__nr">{o.nr_ref}</span>
                    <span className="orders-row__title">{o.tytul}</span>
                  </div>
                  <div className="orders-row__meta">
                    <span className="orders-row__executor">
                      {o.executor_first_name} {o.executor_last_name}
                    </span>
                    {/* jeśli backend kiedyś doda klienta w tym endpointzie, można go tutaj dorzucić */}
                  </div>
                </div>
                <div className="orders-row__actions">
                  <button
                    className="btn btn--primary"
                    onClick={() => handlePrimary(o)}
                    title={primaryLabel}
                  >
                    {primaryLabel}
                  </button>
                  <button
                    className="btn btn--ghost"
                    onClick={() => onViewOrder?.(o.id)}
                    title="Zobacz"
                  >
                    Zobacz
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* FOOTER */}
        <footer className="orders-modal__footer">
          <button className="btn btn--secondary" onClick={onClose}>Zamknij</button>
        </footer>
      </div>
    </div>
  );
}
